import { Tracer, defaultTracer } from "./tracer";

/**
 * Registry for managing tracers in the system
 */
export class TracerRegistry {
  private static instance: TracerRegistry;
  private tracers: Map<string, Tracer> = new Map();
  private activeTracer: string = "null";

  private constructor() {
    // Register the default null tracer
    this.register("null", defaultTracer);
  }

  /**
   * Get the singleton instance of the registry
   */
  public static getInstance(): TracerRegistry {
    if (!TracerRegistry.instance) {
      TracerRegistry.instance = new TracerRegistry();
    }
    return TracerRegistry.instance;
  }

  /**
   * Register a tracer with the registry
   * @param name Name of the tracer
   * @param tracer The tracer implementation
   */
  public register(name: string, tracer: Tracer): void {
    this.tracers.set(name, tracer);
  }

  /**
   * Set the active tracer by name
   * @param name Name of the tracer to activate
   * @throws Error if the tracer doesn't exist
   */
  public setActiveTracer(name: string): void {
    if (!this.tracers.has(name)) {
      throw new Error(`Tracer '${name}' is not registered`);
    }
    this.activeTracer = name;
  }

  /**
   * Get the currently active tracer
   */
  public getActiveTracer(): Tracer {
    return this.tracers.get(this.activeTracer) || defaultTracer;
  }

  /**
   * Check if tracing is enabled (i.e., active tracer is not the null tracer)
   */
  public isTracingEnabled(): boolean {
    return this.activeTracer !== "null";
  }
}

// Export a convenience function to get the active tracer
export function getTracer(): Tracer {
  return TracerRegistry.getInstance().getActiveTracer();
}

// Export a convenience function to check if tracing is enabled
export function isTracingEnabled(): boolean {
  return TracerRegistry.getInstance().isTracingEnabled();
} 